import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 清空 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_9 = [
  _hoisted_8
]

import { onMounted, ref, toRaw } from 'vue'
import SearchBar from '@/components/common/SearchBar.vue'
import {
  disableTeacherCourseware,
  enableTeacherCourseware,
  getSchoolShareCoursewares
} from '@/services/courseware-database'
import { debounce } from '@/utils/common'
import {
  CoursewareTypeMap,
  CoursewareStatusMap,
  CoursewareStatus,
  CoursewareTypeOpts,
  CoursewareType,
  CoursewareStatusOpts
} from '../config'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import PreviewModal from '../components/PreviewModal.vue'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'
import {
  getSubjectEnum,
  getPressVersionEnum
} from '@/services/teaching-material'
import { useStore } from 'vuex'
import { PermissionMap } from '@/utils/auth'
import CollegeEntry from '@/components/common/CollegeEntry.vue'
import { usePageTableContext } from '@evideo/frontend-utils'
import pageTableContextMap from '@/utils/pageTableContextMap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const store = useStore()

// 表单参数
const formParams = ref<any>({
  type: undefined,
  subject: undefined,
  press_version_id: undefined,
  official_book_id: undefined,
  official_book_section_id: undefined,
  author_name: undefined,
  status: undefined
})

// 搜索框的数据
const searchBarParams = ref<string>()

// 表格数据
const tableData = ref<any[]>()

// 分页信息
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 10,
  showTotal: (total: number) => `共${total}条`,
  showQuickJumper: true
})

const loading = ref<boolean>(true)

// 学科信息
const subjectOpts = ref<any[]>([])

const currentInfo = ref()

// 出版设信息
const pressVersionOpts = ref<any[]>([])

// 教材选择弹窗可见性
const selectBookVisible = ref<boolean>(false)

// 选择的教材名
const showBookName = ref<string>('')

const BookTypeMap = {
  OFFICIAL: 1
}

// 预览
const previewVisible = ref<boolean>(false)

// 预览信息
const currentPreview = ref<
  { type: string; url: string; name: string } | undefined
>(undefined)

const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: 80,
    ellipsis: true
  },
  {
    title: '课件名称',
    dataIndex: 'name',
    width: 150,
    ellipsis: true
  },
  {
    title: '课件类型',
    dataIndex: 'type',
    width: 100,
    slots: { customRender: 'type' }
  },
  {
    title: '学科',
    dataIndex: ['subject', 'name'],
    width: 100,
    ellipsis: true
  },
  {
    title: '出版社',
    dataIndex: ['press_version', 'name'],
    width: 120,
    ellipsis: true
  },

  {
    title: '所属教材',
    dataIndex: ['book', 'name'],
    width: 180,
    ellipsis: true
  },
  {
    title: '所属章节',
    dataIndex: 'section_breadcrumb',
    width: 180,
    ellipsis: true
  },
  {
    title: '作者',
    dataIndex: 'author_name',
    width: 100,
    ellipsis: true
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 100,
    slots: { customRender: 'status' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: 180
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 180
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 150,
    slots: { customRender: 'action' }
  }
]

const { getContextInfo, saveContextInfo, deleteContextInfo } = usePageTableContext()

// 页面离开时保存检索条件等上下文信息
const handleSaveContext = () => {
  const pageContext = {
    formParams: toRaw(formParams.value),
    searchBarParams: toRaw(searchBarParams.value),
    currentPage: pagination.value.current,
    showBookName: toRaw(showBookName.value)
  }
  saveContextInfo(pageTableContextMap.SCHOOL_COURSEWARE_DATABASE, pageContext)
}

// 将页面的检索条件上下文注入到参数中
const handleGetContext = () => {
  const context = getContextInfo(pageTableContextMap.SCHOOL_COURSEWARE_DATABASE)
  const {
    formParams: fPrams,
    searchBarParams: sBarParams,
    currentPage,
    showBookName: sbName
  } = context
  if (fPrams) { formParams.value = fPrams }
  if (sBarParams) { searchBarParams.value = sBarParams }
  if (currentPage && currentPage > 1) { pagination.value.current = currentPage }
  if (sbName) { showBookName.value = sbName }
  deleteContextInfo(pageTableContextMap.SCHOOL_COURSEWARE_DATABASE)
}

// 获取分享到学校内的课件信息
const handleGetTableList = debounce(async (params: any) => {
  const qParams = {
    ...toRaw(formParams.value),
    name: searchBarParams.value || undefined,
    page: 1,
    ...params
  }
  try {
    loading.value = true
    const { items, meta } = await getSchoolShareCoursewares(qParams)
    tableData.value = items
    pagination.value = {
      ...toRaw(pagination.value),
      ...meta,
      current: meta.current_page
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    tableData.value = []
    loading.value = false
  }
})

// table变化
const handleTableChange = (page: any) => {
  pagination.value = page
  handleGetTableList({ page: page.current })
}

// 搜索
const handleSearch = () => {
  handleGetTableList({})
}

// 预览
const handlePreview = (record: any) => {
  currentInfo.value = record
  if (record.type === CoursewareType.PPT) {
    console.log('PPT preview')
    const id = record.id
    handleSaveContext()
    router.push(`/content-center/school-coursewares/${id}/preview`)
  } else if (record.type === CoursewareType.FLASH) {
    message.info('SWF课件类型暂不支持在线预览')
  } else {
    currentPreview.value = {
      type: record.type,
      url: record.url,
      name: record.name
    }
    previewVisible.value = true
  }
}

// 取消预览
const handlePreviewCancel = () => {
  currentPreview.value = undefined
  previewVisible.value = false
}

// 显示选择教材弹窗
const handleShowSelectModal = () => {
  selectBookVisible.value = true
}

// 清空教材选择
const handleResetSelectBook = () => {
  selectBookVisible.value = false
  formParams.value.official_book_id = undefined
  formParams.value.official_book_section_id = undefined
  showBookName.value = ''
}

const handleResetForm = () => {
  formParams.value = {
    type: undefined,
    subject_cat_id: undefined,
    press_version_id: undefined,
    official_book_id: undefined,
    official_book_section_id: undefined,
    author_name: undefined,
    status: undefined
  }
  searchBarParams.value = undefined
  showBookName.value = ''
  handleSearch()
}

// 选择教材结束
const handleSelectBookOk = (info: any) => {
  selectBookVisible.value = false
  const { values, labels } = info
  if (values && values.length > 0) {
    if (values[0]) {
      formParams.value.official_book_id = values[0]
    }
    if (values[1]) {
      formParams.value.official_book_section_id = values[1]
    }
  } else {
    formParams.value.official_book_id = undefined
    formParams.value.official_book_section_id = undefined
  }
  if (labels && labels.length > 0) {
    showBookName.value = labels.join('/')
  } else {
    showBookName.value = ''
  }
}

// 获取学科信息
const handleGetSubjectOpts = async () => {
  try {
    const data = await getSubjectEnum()
    subjectOpts.value = data.map(item => ({
      label: item.name,
      value: item.id
    }))
  } catch (err) {
    console.log(err)
    subjectOpts.value = []
  }
}

// 获取出版社信息
const handleGetPressVersionOpts = async () => {
  try {
    const data = await getPressVersionEnum()
    pressVersionOpts.value = data.map(item => ({
      label: item.name,
      value: item.id
    }))
  } catch (err) {
    console.log(err)
    pressVersionOpts.value = []
  }
}

// 修改记录为上架
const handleShelveStatus = async (id: string) => {
  try {
    loading.value = true
    await enableTeacherCourseware(id)
    loading.value = false
    message.success('设置成功')
    handleSearch()
  } catch (error) {
    loading.value = false
    message.error('设置失败，请重试')
  }
}

const handleUnshelveStatus = async (id: string) => {
  try {
    loading.value = true
    await disableTeacherCourseware(id)
    loading.value = false
    message.success('设置成功')
    handleSearch()
  } catch (error) {
    loading.value = false
    message.error('设置失败，请重试')
  }
}

onMounted(() => {
  handleGetContext()
  handleGetPressVersionOpts()
  handleGetSubjectOpts()
  handleGetTableList({ page: pagination.value.current })
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _directive_permission_in_slot = _resolveDirective("permission-in-slot")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "head_body" }, {
        default: _withCtx(() => [
          _createVNode(SearchBar, {
            value: searchBarParams.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (searchBarParams.value = $event)),
            onSearch: handleSearch,
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, {
            suffix: _withCtx(() => [
              _createVNode(CollegeEntry)
            ]),
            _: 1
          }, 8, ["value", "onKeyup"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "content_body" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { class: "from_card_body" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                layout: "inline",
                onKeyup: _withKeys(handleSearch, ["enter"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    style: {"width":"100%"},
                    gutter: [16, 16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "课件类型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: _unref(CoursewareTypeOpts),
                                value: formParams.value.type,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (formParams.value.type = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "学科" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: subjectOpts.value,
                                value: formParams.value.subject_cat_id,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (formParams.value.subject_cat_id = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "出版社" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: pressVersionOpts.value,
                                value: formParams.value.press_version_cat_id,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (formParams.value.press_version_cat_id = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "作者" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formParams.value.author_name,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (formParams.value.author_name = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "状态" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                allowClear: true,
                                options: _unref(CoursewareStatusOpts),
                                value: formParams.value.status,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (formParams.value.status = $event))
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属教材章节" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: handleShowSelectModal
                              }, [
                                (showBookName.value.length > 15)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      title: showBookName.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(showBookName.value.slice(0, 15)) + "... ", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["title"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(showBookName.value || "请选择教材章节"), 1))
                              ]),
                              _withDirectives(_createVNode(_component_a_button, {
                                style: {"margin-left":"10px"},
                                size: "small",
                                onClick: handleResetSelectBook
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, showBookName.value.length > 0]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, {
                    style: {"width":"100%"},
                    gutter: [24, 24],
                    justify: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 4,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            style: {"margin-right":"15px"},
                            onClick: handleResetForm
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: handleSearch
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                dataSource: tableData.value,
                columns: columns,
                rowKey: "id",
                pagination: pagination.value,
                loading: loading.value,
                onChange: handleTableChange,
                scroll: { x: 1300 }
              }, {
                type: _withCtx(({ text }) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(CoursewareTypeMap)[text] || text), 1)
                ]),
                status: _withCtx(({ text }) => [
                  _createVNode(_component_a_tag, {
                    color: _unref(CoursewareStatusMap)[text]?.color
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CoursewareStatusMap)[text]?.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                action: _withCtx(({ record }) => [
                  _createElementVNode("span", null, [
                    _withDirectives(_createVNode(_component_a_popconfirm, {
                      onConfirm: () => handleShelveStatus(record.id),
                      title: "请确认是否将课件设置为上架状态?",
                      placement: "left"
                    }, {
                      default: _withCtx(() => [
                        (+record.status === _unref(CoursewareStatus).UNSHELVE)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_5, "上架"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]), [
                      [_directive_permission_in_slot, _unref(PermissionMap).COURSEWARE_DATABASE_SCHOOL_ENABLE]
                    ]),
                    _withDirectives(_createVNode(_component_a_popconfirm, {
                      onConfirm: () => handleUnshelveStatus(record.id),
                      title: "请确认是否将课件设置为下架状态?",
                      placement: "left"
                    }, {
                      default: _withCtx(() => [
                        (+record.status === _unref(CoursewareStatus).SHELVE)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_6, "下架"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]), [
                      [_directive_permission_in_slot, _unref(PermissionMap).COURSEWARE_DATABASE_SCHOOL_ENABLE]
                    ]),
                    _createVNode(_component_a_divider, { type: "vertical" }),
                    _withDirectives(_createElementVNode("a", {
                      onClick: () => handlePreview(record)
                    }, _hoisted_9, 8, _hoisted_7), [
                      [_directive_permission_in_slot, 
                _unref(PermissionMap).COURSEWARE_DATABASE_SCHOOL_PREVIEW
              ]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["dataSource", "pagination", "loading"])
            ]),
            _: 1
          }),
          _createVNode(PreviewModal, {
            visible: previewVisible.value,
            currentPreview: currentPreview.value,
            data: currentInfo.value,
            onOnCancel: handlePreviewCancel
          }, null, 8, ["visible", "currentPreview", "data"]),
          (selectBookVisible.value)
            ? (_openBlock(), _createBlock(SelectBookModal, {
                key: 0,
                visible: selectBookVisible.value,
                "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (selectBookVisible.value = $event)),
                onOk: handleSelectBookOk,
                type: BookTypeMap.OFFICIAL
              }, null, 8, ["visible", "type"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512)), [
    [_directive_permission, _unref(PermissionMap).COURSEWARE_DATABASE_SCHOOL_LIST]
  ])
}
}

})